export const API_URL = process.env.REACT_APP_API_URL;
export const OKTA_AUTH_BY_TOKEN = `${API_URL}/okta-auth/authorize`;
export const LOGIN_API = `${API_URL}/auth/login`;
export const PERMISSION_API = `${API_URL}/auth/permissions`;
